import React from "react"
import { graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/52/thumb-landscape.webp"


const Post52 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">BOTTEGA VENETA／ミニザノット／10 x16 x7cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <span className="text-small">本記事はボッテガ・ヴェネタ社とは一切関係なく、純粋に情報提供を目的としたものです。記載されているブランド名、製品名はそれぞれの所有者の商標または登録商標です。</span>
          <p>シルクのように滑らかなレザー、ミニマルでありながら存在感のあるコンパクトなサイズ感、そして一目でそれとわかる編み込みデザイン。ボッテガ・ヴェネタの「ミニ・ザノット」は、単なるバッグの枠を超えた、佇まいに静かな強さを宿すプロダクトです。小さなボディに詰め込まれたクラフツマンシップとデザイン哲学。今回はその魅力を探ります。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <figure className="img-small">
        <StaticImage src="https://d2ui3ffbmzhnsd.cloudfront.net/img/product/40967/40967a.jpg"/>
        <span className="text-center">BOTTEGA VENETA／ミニザノット／11 x18 x10cm</span>
      </figure>
      <div className="text-max-width">
        <h1>イタリアの伝統　ヴェネト地方から世界へ</h1>
        <h2>ヴェネトの誇りを名に宿して──工房から生まれた美意識</h2>
      </div>
      <p className="text-max-width">
        1966年、イタリア・ヴェネト州ヴィチェンツァにて誕生したボッテガ・ヴェネタ。ブランド名にある「Bottega」は“工房”を、「Veneta」は“ヴェネト地方の”を意味し、まさに土地の伝統技術を根ざしたものづくりの精神を体現する存在です。<br></br>
        ブランドの哲学を象徴する言葉「When your own initials are enough（自分のイニシャルだけで十分）」には、外側にロゴを掲げずとも、品質と技術そのものが語る、という揺るぎない自負が感じられます。実際、同ブランドのアイコンである“イントレチャート”は、ロゴに代わるビジュアル・アイデンティティとして世界中で認知されています。
      </p>
      <figure>
        <StaticImage src="../../images/posts/52/1.jpg"/>
      </figure>
      <div className="text-max-width">
        <h2>「イントレチャート」が語る、静かなインパクト</h2>
      </div>
      <p className="text-max-width">1970年代初頭に誕生したこの編み込み技法は、レザーを細く裁断し、斜めに組み合わせて仕上げる独自のもの。柔らかくも強く、幾何学的な美を宿すデザインは、機能美と詩的な美しさを両立しています。機械では再現できない微細なニュアンスにこそ、職人の手の温もりがにじみ出ています。</p>
      <div className="text-max-width">
        <h2>変化を恐れない美学──クリエイティブ・ディレクションの歩み</h2>      
      </div>
      <p className="text-max-width">
        ブランドの現代的な飛躍は、2001年から17年間ディレクションを手掛けたトーマス・マイヤーによってもたらされました。控えめなラグジュアリーを標榜し、シグネチャーであるイントレチャートを軸に静かなブランド価値を築き上げました。<br></br>
        その後、2018年に就任したダニエル・リーは、伝統を尊重しながらも斬新なアプローチを加え、ブランドに新風を吹き込みます。そんな彼の手による代表作のひとつが、「ザノット」シリーズです。
      </p>
      <div className="text-max-width">
        <h1>ミニ・ザノット　デザインの特徴と魅力</h1>
        <h2>“結び”に宿る造形美──ミニ・ザノットの魅力とは？</h2>
      </div>
      <p className="text-max-width">ブランドを象徴するイントレチャートを贅沢にまとった、ミニマルで洗練されたショルダーバッグです。すっきりとした長方形のフォルムに、さりげなく添えられた小さな“ノット（結び目）”がデザインのアクセントとなり、静かな存在感を放ちます。</p>
      <p className="text-max-width">小ぶりなサイズながら、スマートフォンやリップ、カードケースなどの必需品がきちんと収まる収納力を備え、日常使いにも頼れる機能性。長めのストラップで肩がけやクロスボディが可能なので、両手をあけたいシーンでもスマートに持ち運べます。</p>
      <p className="text-max-width">なめらかな曲線と職人技の結晶である編み込みが織りなす、静かで力強い佇まい。ロゴに頼らずとも一目でそれとわかる美しさは、まさに“語らないこと”が語るラグジュアリー。シンプルな装いにさっと合わせるだけで、品のある個性を演出してくれるバッグです。</p>                                                                            
      <div className="text-max-width">
        <h2>レザーの美しさと、手作業の尊さ</h2>
      </div>
      <p className="text-max-width">素材には主にナッパレザー、カーフスキン、ラムスキンなどが使われ、その滑らかさと強度は世界でも評価が高いもの。革の裁断からイントレチャートの編み込みまで、一枚の革から、精密にストリップを切り出し、均一な幅で編み込む作業。そのすべてが人の手によって仕上げられており、工芸品としての価値が宿っています。</p>
      <p className="text-max-width">このような伝統的な手法で完成した製品は、現代のファッション産業における職人技の価値を体現していると言えるでしょう。</p>
      <div className="text-max-width">
        <h1>現代ファッションにおける位置づけ</h1>
        <h2>デザイン言語とアイデンティティ</h2>
      </div>
      <p className="text-max-width">興味深いのは、ロゴを前面に押し出さないデザイン哲学が、視覚的なインパクトが求められるSNS時代において、むしろ強い存在感を放っているという点です。インスタグラムやTikTokといったビジュアル重視のプラットフォームでは、ブランドロゴそのものよりも、独自のフォルムや質感といった“デザインの語彙”が印象を左右するというのが、ファッションアナリストたちの共通見解でもあります。</p>
      <p className="text-max-width">たとえば、ミニ・ザノットに見られる彫刻的なシルエットや、ボッテガ・ヴェネタを象徴するイントレチャートの繊細な編み込みパターンは、ロゴがなくとも一目で識別できる“視覚のサイン”となっています。こうしたデザイン自体がブランドを語る時代において、ミニ・ザノットは「ロゴに頼らないブランディング」の好例として、専門家の間でも注目を集めています。</p>
      <div className="text-max-width">
        <h2>サステナビリティとラグジュアリーの未来</h2>
      </div>
      <p className="text-max-width">現代のファッション産業において、サステナビリティへの意識は年々高まりを見せています。その視点から見ると、長く使うことを前提とした高品質な製品には、単なるラグジュアリーを超えた意義があると考えられます。</p>
      <p className="text-max-width">消費者行動に関する研究によれば、「トレンドに左右されない普遍的なデザイン」は、短期消費を繰り返すサイクルとは対照的に、資源の持続的な活用を可能にするという見方が広がりつつあります。高品質で永く使えるデザインは、結果として環境に配慮した新しい消費のあり方とも言えるでしょう。</p>
      <p className="text-max-width">また、同ブランドの親会社であるケリング・グループは、環境負荷の軽減やサプライチェーンの透明性向上に取り組む姿勢を、公式サイトや年次報告書などで明らかにしています。職人による手作業を重視した製造工程が、大量生産と比べてどのようなエネルギー消費の差を生むかは、今後の研究に委ねられる部分でもあります。</p>
      <div className="text-max-width">
        <h1>ラグジュアリー製品との新しい関わり方</h1>
        <h2>シェアリングとレンタルの選択肢</h2>
      </div>
      <p className="text-max-width">高級ブランド製品を「所有」することへの価値観は、ここ数年で大きく変化してきました。とくに若年層を中心に、「モノ」よりも「体験」や「アクセス」に価値を見出す傾向が強まり、それにともないラグジュアリーファッションのレンタルやサブスクリプションサービスの利用が広がっています。</p>
      <p className="text-max-width">これにより、多彩なデザインのバッグを試す機会が広がり、これまで高級市場に接点のなかった層にもその魅力が届くようになりました。特に個性的なデザインのバッグは、特定のスタイルやシーンに合わせて「借りる」という行為との相性も良く、新たな楽しみ方を提案してくれます。</p>
      <figure className="img-small">
        <StaticImage src="https://d2ui3ffbmzhnsd.cloudfront.net/upload_images/mail/template/68148eb4a8368.png"/>
      </figure>
      <div className="text-max-width">
        <h2>ヴィンテージとセカンダリーマーケット</h2>
      </div>
      <p className="text-max-width">もう一つの注目すべき市場動向は、ヴィンテージやセカンダリーマーケットへの関心の高まりです。リサーチ会社の市場調査によれば、新品だけでなく、過去の名作や限定モデルにも価値を見出す動きが加速しているといいます。</p>
      <p className="text-max-width">時代を超えて魅力を放つデザインを持つブランドは、この流れと非常に相性が良い存在です。たとえば、ボッテガ・ヴェネタを象徴するイントレチャートの編み込みパターンは、流行に左右されにくく、時間の経過とともに革の風合いが深まり、より一層の存在感を纏っていきます。</p>
      <p className="text-max-width">現在市場に出回っているアイテムも、将来的にはセカンダリーマーケットで再評価される可能性を秘めています。「使い捨て」ではなく「受け継ぐ」という視点は、ラグジュアリー製品が持つ本質的な価値を改めて考えさせてくれます。</p>
      <div className="text-max-width">
        <h1>小さな革製品が語るもの</h1>
      </div>
      <p className="text-max-width">ミニ・ザノットのような小型のレザーアイテムは、単なるファッション小物という枠を超えて、文化的なメッセージを含んだ存在です。それは、大量生産と短期消費の価値観に対するオルタナティブであり、職人の技術と美意識の継承を示すものでもあります。</p>
      <p className="text-max-width">独創的でありながら、決して主張しすぎないバランスの取れたデザイン。素材と仕立てに対する妥協のない姿勢。そして、流行に左右されない普遍的な美しさ。こうした要素は、現代のファッション産業において新たな価値として再評価されています。</p>
      <p className="text-max-width">日々の生活の中で少しずつ手に馴染み、時の経過とともに愛着が増していくような存在こそ、変化の激しい時代において真の豊かさを語ってくれるのかもしれません。</p>
      <p className="text-max-width">イタリアの伝統に根ざした革製品の旅は、こうした製品を通じて、これからも続いていくことでしょう。それは単なるブランドの物語ではなく、私たちがモノとどう向き合い、どのような価値を大切にしていくかという問いかけでもあります。</p>
      <p className="text-max-width">ミニ・ザノットのような革製品を手に取る時、私たちはその小さな編み目の中に、技術と美学、そして時間の流れを感じることができるのです。</p>
      <div className="border"></div>
      <span className="text-small">免責事項: 本記事はボッテガ・ヴェネタ社およびケリング・グループとは一切関係のない、独立した分析・考察です。記事中の商標はそれぞれの所有者に帰属します。この記事は情報提供のみを目的としており、特定の製品の購入や投資を推奨するものではありません。</span>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post52

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 52}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`